import { BasicWithLibelleModel } from './../basic/basicWithLibelle.model';
import { BasicModel } from '../basic/basic.model';

export class ModeReglModel extends BasicModel implements BasicWithLibelleModel {
        // max length 7
        code: string;
        // max length 30
        libelle: string;
        codeCoda: string;
}
